import PropTypes from "prop-types";
import { useNavigate } from "react-router";
import Button from "@shared/v2/Button";
import TextButton from "@shared/v2/TextButton";
import { ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import ZoomCard from "./shared/ZoomCard";

const RecruiterCard = ({ hasSubscription }) => {
  const navigate = useNavigate();
  return (
    <ZoomCard
      actions={
        <>
          {hasSubscription && (
            <TextButton
              className="tw-px-0 tw-flex tw-items-center tw-gap-[4px]"
              size="medium"
              onClick={() => window.open("/launch?slug=brivity-recruiter", "_blank")}
            >
              Launch Recruiter.ai <ArrowUpRightFromSquareSolidV6 />
            </TextButton>
          )}
          {!hasSubscription && (
            <Button
              size="medium"
              schema="secondary"
              onClick={() =>
                window.open(
                  "/launch?slug=brivity-recruiter&redirectPath=/recruiter%3FshowSignUp%3Dtrue",
                  "_blank",
                )
              }
            >
              Purchase
            </Button>
          )}
          {!hasSubscription && (
            <TextButton className="tw-px-0" size="medium" onClick={() => navigate("recruiter_ai")}>
              Learn More
            </TextButton>
          )}
        </>
      }
      onClick={
        hasSubscription ? () => window.open("/launch?slug=brivity-recruiter") : () => navigate("recruiter_ai")
      }
      onClickText={hasSubscription ? "Launch" : "Learn More"}
      title="Recruiter.ai"
      subscribed={hasSubscription}
      description="Revolutionize Real Estate recruiting with AI innovation! Leverage the power of Brivity to post open positions, plus qualify and nurture candidates in minutes."
      imgSrc="/images/bg-card-recruiter.png"
      imgClassName="tw-mx-[-24px]"
    />
  );
};

RecruiterCard.propTypes = {
  hasSubscription: PropTypes.bool,
};

RecruiterCard.defaultProps = {
  hasSubscription: false,
};

export default RecruiterCard;
